/**
 * Framer motion does not support IE11, specifically in relation to the use of Proxies.
 * The following creates a wrapper for framer motion which sets all supported html/svg elements on an object,
 * rather than letting the proxy handle them dynamically.
 * We then resolve any `framer-motion` imports to this file in our Webpack config to ensure that Chakra (and others) are using it.
 *
 * See https://github.com/framer/motion/issues/364#issuecomment-723137822 for more context
 */

import {
    createDomMotionComponent,
    motion as origMotion,
} from "../../../node_modules/framer-motion";

// Copied from internal framer-motion supported-elements.ts -
//  https://github.com/framer/motion/blob/cfd5098a44f97384d855bb269a23a5fba75ae4f9/src/render/dom/utils/supported-elements.ts

export const htmlElements = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "webview",
];
export const svgElements = [
    "animate",
    "circle",
    "clipPath",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use",
    "view",
];

// Adapted from https://github.com/framer/motion/commit/b4319c78fb4bde28ce0d2a8008df48d7e3fd1c8b
const createNonProxyMotion = () => {
    let motionProxy = {
        custom: createDomMotionComponent,
    };
    motionProxy = htmlElements.reduce((acc, key) => {
        acc[key] = createDomMotionComponent(key);
        return acc;
    }, motionProxy);
    motionProxy = svgElements.reduce((acc, key) => {
        acc[key] = createDomMotionComponent(key);
        return acc;
    }, motionProxy);
    return motionProxy;
};

const isIE11 = /Trident.*rv:11\.0/.test(navigator.userAgent);

export const motion = !isIE11 ? origMotion : createNonProxyMotion();
export * from "../../../node_modules/framer-motion";
